
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spaced-repetition",
      function () {
        return require("private-next-pages/spaced-repetition.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spaced-repetition"])
      });
    }
  